import { $ } from './bootstrap';
import '../../sass/base/components/scroll-icon.scss';

const DISPLAYED = 'scroll-icon-displayed';

function srcollIconShow() {
    const $scrollIcon = $(`
        <div class="scroll-icon-container">
            <div class="mouse-scroll">
                <div class="mouse">
                    <div class="wheel"></div>
                </div>
                <div>
                    <span class="m-scroll-arrows one"></span>
                    <span class="m-scroll-arrows two"></span>
                    <span class="m-scroll-arrows three"></span>
                </div>
            </div>
        </div>    
    `);
    $(document.body).append($scrollIcon);
    $(() => {
        $(window).one('scroll', () => {
            $scrollIcon.fadeOut(() => $scrollIcon.remove());
            if (window.innerWidth < 1250) {
                sessionStorage.setItem(DISPLAYED, '1');
            }
        });
    });
    $scrollIcon.show();
}

(() => {
    if ($(window).scrollTop() > 0) {
        return; // page is scrolled
    }
    if ($('div.container-fluid.top-bg').length !== 1) {
        return; // there is no top-bg banner
    }
    if (sessionStorage.getItem(DISPLAYED)) {
        return; // scroll has been used when icon is visible
    }
    srcollIconShow();
})();
